/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowusethis3Inputs */

const en_aiflowusethis3 = /** @type {(inputs: Aiflowusethis3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take this one`)
};

const de_aiflowusethis3 = /** @type {(inputs: Aiflowusethis3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese nehmen`)
};

/**
* | output |
* | --- |
* | "Take this one" |
*
* @param {Aiflowusethis3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowusethis3 = /** @type {((inputs?: Aiflowusethis3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowusethis3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowusethis3(inputs)
	return de_aiflowusethis3(inputs)
});
export { aiflowusethis3 as "aiFlowUseThis" }